/* ============================================================================
   aurora-lookbook-slider.js — <aurora-lookbook>
   Syncs hotspot dots <-> a scroll-snap product carousel. Click a dot to move
   the carousel to that product; scrolling the carousel activates the matching
   dot. Arrows step one slide; a counter shows the active product.
   ========================================================================== */
if (!customElements.get('aurora-lookbook')) {
  customElements.define(
    'aurora-lookbook',
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-lk-track]');
        this.dots = Array.from(this.querySelectorAll('[data-lk-dot]'));
        this.slides = Array.from(this.querySelectorAll('[data-lk-slide]'));
        this.current = this.querySelector('[data-lk-current]');
        this.progressThumb = this.querySelector('[data-lk-progress-thumb]');
        this.prev = this.querySelector('[data-lk-prev]');
        this.next = this.querySelector('[data-lk-next]');
        if (!this.track || !this.slides.length) return;

        this.active = 0;
        this.lockUntil = 0;

        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
        if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
        if (this.next) this.next.addEventListener('click', () => this.step(1));
        this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });

        this.setActive(0);
      }

      goTo(i) {
        i = Math.max(0, Math.min(this.slides.length - 1, i));
        var slide = this.slides[i];
        // scrollLeft target relative to the track's scroll content
        var left = slide.offsetLeft - this.track.offsetLeft;
        this.lockUntil = Date.now() + 600; // ignore scroll echo while animating
        this.track.scrollTo({ left: left, behavior: 'smooth' });
        this.setActive(i);
      }

      step(dir) {
        var n = this.slides.length;
        this.goTo((this.active + dir + n) % n); // loop
      }

      onScroll() {
        if (Date.now() < this.lockUntil) return;
        var center = this.track.scrollLeft + this.track.clientWidth / 2;
        var best = 0;
        var bestDist = Infinity;
        for (var i = 0; i < this.slides.length; i++) {
          var s = this.slides[i];
          var mid = s.offsetLeft - this.track.offsetLeft + s.offsetWidth / 2;
          var d = Math.abs(mid - center);
          if (d < bestDist) { bestDist = d; best = i; }
        }
        if (best !== this.active) this.setActive(best);
      }

      setActive(i) {
        this.active = i;
        this.dots.forEach((dot, idx) => dot.classList.toggle('is-active', idx === i));
        this.slides.forEach((s, idx) => s.classList.toggle('is-active', idx === i));
        if (this.current) this.current.textContent = i + 1;
        if (this.progressThumb) {
          var n = this.slides.length;
          this.progressThumb.style.width = 100 / n + '%';
          this.progressThumb.style.left = (i * 100) / n + '%';
        }
        if (this.prev) this.prev.toggleAttribute('disabled', false);
        if (this.next) this.next.toggleAttribute('disabled', false);
      }
    }
  );
}
